export default __webpack_public_path__ + "static/media/html5.4678ca2e.svg";